import {
    FETCH_DATA_RECEIVED_REQUEST,
    FETCH_DATA_RECEIVED_SUCCESS,
    FETCH_DATA_RECEIVED_FAILURE,
} from '../../actions/connection/connection-received-actions';

const initialState = {
    data: {},
    isLoading: false,
    error: null,
};

const ConnectionReceivedReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_RECEIVED_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_RECEIVED_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data:action.payload,
            };
        case FETCH_DATA_RECEIVED_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ConnectionReceivedReducer;